module.exports = __webpack_public_path__ + "img/ups-c.a7a1dc2f.png";